import { ICellRendererParams } from 'ag-grid-community'

import { Alert } from '@/gen/inventory/v1/alert_pb'

import { EventProperties } from '@/lib/analytics/events'

import { EmptyCellValue } from '@/components/ag-cells/empty-cell-value'
import { AlertSeverityBadge } from '@/components/shared/alert-severity-badge/alert-severity-badge'

interface CompanyDrawerSeverityCellParams extends ICellRendererParams<Alert> {
  extraTrackingProps?: EventProperties
  readOnly?: boolean
}

export const CompanyDrawerSeverityCell = ({ data }: CompanyDrawerSeverityCellParams) => {
  if (!data) {
    return <EmptyCellValue />
  }

  return <AlertSeverityBadge level={data.severity} />
}
